import { Injectable, signal, computed} from '@angular/core';

export interface WorksurfaceColor {
  code: string;
  name: string;
}

@Injectable({ providedIn: 'root' })
export class WorksurfaceService {

  private worksurfaceColors: WorksurfaceColor[] = [
    {code: 'W960', name: 'Classic White'},
    {code: 'U779', name: 'Fog Gray'},
    {code: 'WA7976', name: 'White Cypress'},
    {code: 'U999ST19', name: 'Black Cypress'},
    {code: 'WA7949', name: 'Asian Night'},
    {code: 'K458', name: 'Lakeland Salt'},
    {code: 'H3041', name: 'Natural Eucalyptus'},
    {code: 'K525', name: 'Blonde Surfside Ash'}
  ]

  /** Default **/
  private readonly selection = signal<WorksurfaceColor>(this.worksurfaceColors[0]);

  /** Getter **/
  readonly availableWorksurfaces = computed(() => this.worksurfaceColors);

  /** Getter for current selection **/
  readonly selectedWorksurface = computed(() => this.selection());

  /** Setter **/
  setSelectedWorksurface(code: string): void {
    const color = this.worksurfaceColors.find(c => c.code === code);
    if (color) {
      this.selection.set(color)
    }
  }
}
